import { Component, OnInit, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { InternshipserviceService } from '../internshipservice.service';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import Swal from 'sweetalert2';




declare var bootstrap: any; // REQUIRED for Bootstrap modal

import { AbstractControl, ValidationErrors } from '@angular/forms';
export function minCharsThenSpace(minChars: number) {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value || typeof value !== 'string') return null;

    // Trim left to prevent starting spaces
    const trimmed = value.trimStart();

    // At least minChars characters before any space
    const regex = new RegExp(`^[A-Za-z0-9]{${minChars},}([ A-Za-z0-9]*)?$`);

    return regex.test(trimmed) ? null : { minCharsThenSpace: true };
  };
}

/**
 * Phone validator – no spaces, only digits, exactly 10
 */
export function phoneNoSpacesValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = control.value;
  if (!value) return null;

  return /^[0-9]{10}$/.test(value)
    ? null
    : { invalidPhone: true };
}
export function noWhitespaceValidator(
  control: AbstractControl
): ValidationErrors | null {
  if (typeof control.value === 'string' && control.value.trim().length === 0) {
    return { whitespace: true };

  }
  return null;
}


@Component({
  selector: 'app-apply',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
  templateUrl: './apply.component.html',
  styleUrls: ['./apply.component.scss'],
  encapsulation: ViewEncapsulation.None
})


export class ApplyComponent implements OnInit {
  @ViewChild('resumeInput') resumeInput!: ElementRef<HTMLInputElement>;

  applicationForm!: FormGroup;

  submitted = false;

  resumeFile: File | null = null;
  resumeError = '';

  // Modal state
  modalType: 'success' | 'error' = 'success';
  modalTitle = '';
  modalMessage = '';
    resumeUploading = false;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private internshipService: InternshipserviceService
  ) { }

  ngOnInit(): void {
    const type = this.route.snapshot.queryParamMap.get('type');

    this.applicationForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      name: ['', [Validators.required, Validators.minLength(3)]],
      address: ['', [Validators.required, Validators.minLength(3)]],
      college: ['', [Validators.required, Validators.minLength(3)]],
      major: ['', [Validators.required, Validators.minLength(3)]],
      interestReason: ['', [Validators.required, Validators.minLength(3)]],
      phone: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],

      qualification: ['', Validators.required],
      qualification_other: [''],

      graduationYear: ['', Validators.required],

      comments: [''],
      linkedin: [''],
      interestType: ['', Validators.required],
      terms: [false, Validators.requiredTrue],
      resume_url: ['', Validators.required],
    });

    this.applicationForm.get('qualification')?.valueChanges.subscribe(value => {
      const otherCtrl = this.applicationForm.get('qualification_other');
      if (!otherCtrl) return;
      if (value === 'Other') {
        otherCtrl?.setValidators([
          Validators.required,
          minCharsThenSpace(3)
        ]);
      } else {
        otherCtrl?.clearValidators();
        otherCtrl.setErrors(null);
        otherCtrl?.reset();
      }

      otherCtrl?.updateValueAndValidity();
    });

    // Auto-select interest type
    this.applicationForm.patchValue({
      interestType:
        type === 'programming' ? 'Programming' : 'Non-Programming',
    });
  }

  // ================= SUBMIT =================
// ================= SUBMIT =================
submit(): void {

  this.submitted = true;

  // Mark all fields as touched
  this.applicationForm.markAllAsTouched();

  // ---------------------------------------------------------
  // Resume still uploading
  // ---------------------------------------------------------
  if (this.resumeUploading) {
    Swal.fire({
      title: 'Please wait',
      text: 'Your resume is still uploading. Please wait until the upload is completed.',
      icon: 'info',
      confirmButtonText: 'OK',
    });

    return;
  }

  // ---------------------------------------------------------
  // Form validation
  // ---------------------------------------------------------
  if (this.applicationForm.invalid) {

    Swal.fire({
      title: 'Form Error',
      text: 'Please fill all required fields correctly before submitting.',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    return;
  }

  // ---------------------------------------------------------
  // Get form values
  // ---------------------------------------------------------
  const raw = this.applicationForm.value;

  const applicationData = {
    email: raw.email,
    name: raw.name,
    address: raw.address,
    phone_number: raw.phone,
    college_name: raw.college,
    qualification: raw.qualification,
    area_of_study: raw.major,
    graduation_year: raw.graduationYear,
    reason: raw.interestReason,
    comments: raw.comments,
    linkedin: raw.linkedin,
    interested_type: raw.interestType,

    // S3 URL
    resume_url: raw.resume_url,

    status: 'Pending',
    remarks: 'N/A',
  };

  console.log('Form Submitted:', applicationData);

  // ---------------------------------------------------------
  // Submit application
  // ---------------------------------------------------------
  this.internshipService.submitApplication(applicationData).subscribe({

    next: (response) => {

      console.log('Success:', response);

      Swal.fire({
        title: 'Success!',
        text: 'Application Submitted Successfully!',
        icon: 'success',
        confirmButtonText: 'OK',
      }).then(() => {

        // Reset form
        this.applicationForm.reset();

        this.submitted = false;

        // Reset resume
        this.resumeFile = null;
        this.resumeError = '';
        this.resumeUploading = false;

        // Reset file input
        if (this.resumeInput) {
          this.resumeInput.nativeElement.value = '';
        }

        // Restore default interest type if required
        const type =
          this.route.snapshot.queryParamMap.get('type');

        this.applicationForm.patchValue({
          interestType:
            type === 'programming'
              ? 'Programming'
              : 'Non-Programming'
        });

      });

    },

    error: (error) => {

      console.error('Error:', error);

      Swal.fire({
        title: 'Error!',
        text:
          error?.error?.message ||
          'Something went wrong while submitting the application.',
        icon: 'error',
        confirmButtonText: 'Close',
      });

    },

  });
}

  // ================= MODAL =================
  showModal(
    title: string,
    message: string,
    type: 'success' | 'error'
  ): void {
    this.modalTitle = title;
    this.modalMessage = message;
    this.modalType = type;

    const modalElement = document.getElementById('responseModal');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  // =========================================================
  // RESUME UPLOAD
  // =========================================================

  onResumeUpload(event: Event): void {

    const input = event.target as HTMLInputElement;

    this.resumeError = '';

    if (!input.files || input.files.length === 0) {
      return;
    }

    const file = input.files[0];

    // ---------------------------------------------------------
    // Validate PDF
    // ---------------------------------------------------------

    if (
      file.type !== 'application/pdf' &&
      !file.name.toLowerCase().endsWith('.pdf')
    ) {

      this.resumeError = 'Only PDF files are allowed';

      this.resumeFile = null;

      this.applicationForm.patchValue({
        resume_url: ''
      });

      input.value = '';

      return;
    }


    // ---------------------------------------------------------
    // Validate file size - 2MB
    // ---------------------------------------------------------

    if (file.size > 2 * 1024 * 1024) {

      this.resumeError = 'File size must be less than 2MB';

      this.resumeFile = null;

      this.applicationForm.patchValue({
        resume_url: ''
      });

      input.value = '';

      return;
    }


    // ---------------------------------------------------------
    // Store selected file
    // ---------------------------------------------------------

    this.resumeFile = file;

    this.resumeUploading = true;

    this.applicationForm.patchValue({
      resume_url: ''
    });


    // ---------------------------------------------------------
    // Upload to S3 through API
    // ---------------------------------------------------------

    this.internshipService
      .uploadFile(file, 'resume')
      .subscribe({

        next: (response) => {

          this.resumeUploading = false;

          console.log('Resume upload response:', response);

          if (
            response &&
            response.status === 200 &&
            !response.issues &&
            response.result?.file_url
          ) {

            // Store S3 URL in form
            this.applicationForm.patchValue({
              resume_url: response.result.file_url
            });

            this.resumeError = '';

            console.log(
              'Resume S3 URL:',
              response.result.file_url
            );

          } else {

            this.resumeError =
              response?.message ||
              'Failed to upload resume';

            this.resumeFile = null;

            this.applicationForm.patchValue({
              resume_url: ''
            });

            input.value = '';
          }

        },

        error: (error) => {

          this.resumeUploading = false;

          console.error(
            'Resume upload error:',
            error
          );

          this.resumeError =
            error?.error?.message ||
            'Failed to upload resume. Please try again.';

          this.resumeFile = null;

          this.applicationForm.patchValue({
            resume_url: ''
          });

          input.value = '';
        }

      });

  }
}